import { render, staticRenderFns } from "./paramet04.vue?vue&type=template&id=6fb49a58&scoped=true&"
import script from "./paramet04.vue?vue&type=script&lang=js&"
export * from "./paramet04.vue?vue&type=script&lang=js&"
import style0 from "./paramet04.vue?vue&type=style&index=0&id=6fb49a58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb49a58",
  null
  
)

export default component.exports